var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.hasVorlagen()
    ? _c("div", { staticClass: "small-12 large-9 column mb-5 mb-6@large" }, [
        _c("h2", [
          _vm._v(_vm._s(_vm._f("translate")("txtDownloadTemplateDetailTitle"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "download bg-shade-light my-children-prj2 px-prj py-1 px-prj2",
          },
          [
            _c(
              "div",
              { staticClass: "download__container my-children-prj" },
              [
                _vm._l(this.vorlagen, function (vorlage) {
                  return [
                    _vm.canDisplayVorlage(vorlage)
                      ? _c(
                          "a",
                          {
                            staticClass:
                              "content-list d-flex align-items-center bg-white text-decoration-none text-shade-darker",
                            attrs: { href: vorlage.token, download: "" },
                          },
                          [
                            _c(
                              "figure",
                              {
                                staticClass:
                                  "content-list__figure bg-shade embed-responsive embed-responsive-1/1 position-relative flex-child-fix",
                              },
                              [
                                vorlage.token
                                  ? _c("img", {
                                      staticClass:
                                        "svg-icon object-fit-contain position-absolute t-0 l-0",
                                      attrs: {
                                        src: vorlage.iconUrl,
                                        height: "60",
                                        width: "60",
                                      },
                                    })
                                  : [
                                      _c(
                                        "svg",
                                        {
                                          staticClass:
                                            "svg-icon object-fit-contain position-absolute t-0 l-0",
                                          attrs: {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            viewBox: "0 0 60 60",
                                          },
                                        },
                                        [
                                          _c("path", {
                                            attrs: {
                                              d: "M39.8 47.6c1.2 0 2.2-1 2.2-2.2V14.6c0-1.2-1-2.2-2.2-2.2H23.9c-.9 0-2 .5-2.7 1.1L15 19.7c-.6.6-1.1 1.8-1.1 2.7v23.1c0 1.2 1 2.2 2.2 2.2h23.7zm0-33v30.8H16.2V22.3h5.5c1.2 0 2.2-1 2.2-2.2v-5.5h15.9zm-18.1 1.5v4h-4l4-4z",
                                              fill: "#fff",
                                            },
                                          }),
                                        ]
                                      ),
                                    ],
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "content-list__desc d-block mx-prj2 line-height-14",
                              },
                              [
                                vorlage.name
                                  ? _c(
                                      "span",
                                      { staticClass: "font-weight-bold" },
                                      [_vm._v(_vm._s(vorlage.name))]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "content-list__btn btn btn--prj-min-x ml-auto mr-prj2 show-for-medium",
                                attrs: { title: _vm.getDownloadTitle() },
                              },
                              [
                                [
                                  _c(
                                    "svg",
                                    {
                                      staticClass:
                                        "svg-icon fill-white text-xsmall position-relative tn-1px mr-2",
                                      attrs: {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        viewBox: "0 0 11.92 12.76",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          d: "M.75 12.76a1 1 0 01-.51-.28.85.85 0 01-.24-.6V9a.85.85 0 011.19-.81.84.84 0 01.54.84v1.82c0 .14 0 .14.13.14h8.2c.13 0 .13 0 .13-.13V9.09a.87.87 0 01.36-.75.82.82 0 01.85-.09.8.8 0 01.51.67 1.21 1.21 0 010 .19v2.72a.89.89 0 01-.24.66.94.94 0 01-.43.25h-.08z",
                                          fill: "#3a3a39",
                                          "fill-rule": "evenodd",
                                        },
                                      }),
                                      _c("path", {
                                        attrs: {
                                          d: "M6.19 0a2.43 2.43 0 01.37.16.84.84 0 01.38.73v5.42l.22-.21c.3-.3.6-.61.91-.91a.85.85 0 011.07-.11.87.87 0 01.34 1 1.26 1.26 0 01-.35.47L7.72 8 6.65 9a.88.88 0 01-1.24 0L3.78 7.34c-.33-.33-.67-.66-1-1a.8.8 0 01-.13-.85.85.85 0 01.69-.49 1 1 0 01.85.35c.31.32.62.62.93.93l.08.07V1a.93.93 0 01.21-.69.87.87 0 01.46-.31H6z",
                                          fill: "#3a3a39",
                                          "fill-rule": "evenodd",
                                        },
                                      }),
                                    ]
                                  ),
                                ],
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t" +
                                    _vm._s(_vm._f("translate")("txtDownload")) +
                                    "\n\t\t\t\t\t\t"
                                ),
                              ],
                              2
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                }),
              ],
              2
            ),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }